module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/fails.js
// module id = 3
// module chunks = 0 1